import { rulesActionType } from '../../constants'

const initialState = {
  templates: [],
  list: { records: [], totalRecords: 0, currentPage: 1, totalPage: 1 },
  detail: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case rulesActionType.FETCH_RULE_TEMPLATES:
      return { ...state, templates: action.payload || [] }
    case rulesActionType.FETCH_RULES:
      return { ...state, list: action.payload || initialState.list }
    case rulesActionType.FETCH_RULE:
      return { ...state, detail: action.payload || null }
    default:
      return state
  }
}
